module.exports = __webpack_public_path__ + "img/AT0000002568200.5406573d.png";